/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { memo } from 'react';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SecurityIcon from '@mui/icons-material/Security';
import WifiOffIcon from '@mui/icons-material/WifiOff';

import { LoginErrorKey } from '../../../types/login/LoginError';
import { useErrorMessageWithIconStyles } from '../../ErrorMessageWithIcon/ErrorMessageWithIcon.styles';

interface ErrorIconProps {
  errorKey: LoginErrorKey;
}

export const ErrorIcon = memo<ErrorIconProps>(({ errorKey }) => {
  const classes = useErrorMessageWithIconStyles();

  switch (errorKey) {
    case 'network_error':
      return <WifiOffIcon className={classes.errorIcon} />;
    case 'invalid_client':
    case 'invalid_request':
    case 'not_authorized':
      return <SecurityIcon className={classes.errorIcon} />;
    default:
      return <ErrorOutlineIcon className={classes.errorIcon} />;
  }
});
